import en from './en.json';
import de from './de.json';
import es_mx from './es-mx.json';
import fil from './fil.json';
import fr from './fr.json';
import id from './id.json';
import it from './it.json';
import pt_br from './pt-br.json';
import ru from './ru.json';
import tr from './tr.json';
import ua from './ua.json';

export { de, en, es_mx, fil, fr, id, it, pt_br, ru, tr, ua };
